import slick from '../plugins/slick.js';
import cookie from '../plugins/jquery.cookie.js';
import Headroom from '../plugins/headroom.js';

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Base = {
  // All pages
  common: {
    init: function() {
      /////
      // JavaScript to be fired on all pages
      /////

      // jQuery Random
      jQuery.fn.random = function() {
        var randomIndex = Math.floor(Math.random() * this.length);  
        return jQuery(this[randomIndex]);
      };

      // Donation Form
      $('.gfield.prices input').on('change', function(){
        $('.gfield.prices label').each(function(){
          var $this = $(this);
          if ($this.siblings('input:checked').length) {
            $this.addClass('checked');
            $('.gfield.number input, .gfield.gfield_total input').val(parseInt($this.siblings('input:checked').val()).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        }));
          } else {
            $this.removeClass('checked');
          }
        });
      });
      $('.gfield.number input').on('change', function(){
        var $this = $(this);
        $('.gfield.gfield_total input').val(parseInt($this.val()).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        }));
        $('.gfield.prices input').each(function() {
          var $this = $(this);
          $this.prop('checked', false);
        });
        $('.gfield.prices label').each(function() {
          var $this = $(this);
          $this.removeClass('checked');
        });
      });
      if ($('.gfield.gfield_total input').length) {
        setTimeout(function(){$('.gfield.gfield_total input').val(parseInt($('.gfield.number input').val()).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        }))},100);
      }
      setInterval(function(){console.log($('.gfield.gfield_total input').val())}, 100);

      // Quotes
      $('.quotes-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 1000,
        fade: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="prev">&nbsp;</div>',
        nextArrow: '<div class="next">&nbsp;</div>',
        adaptiveHeight: false
      });

      // Sticky Header
      var myElement = document.querySelector(".global-header");
      var headroom  = new Headroom(myElement, {
        "offset": 50,
        "tolerance": 0
      });
      headroom.init();

      // Resource Filters
      $('.resource-filter-toggle').click(function(e){
        e.preventDefault();
        $('.resource-filter-toggle').removeClass('active');
        $('.resource-filter-toggle[href="' + $(this).attr('href') + '"]').addClass('active');
        $('#ajax-pagination a').remove();
        $('#ajax-posts').fadeOut();
        $('#ajax-posts').load($(this).attr('href') + ' #ajax-posts>*', function(){
          $('#ajax-posts').fadeIn();
        });
        $('#ajax-pagination').load($(this).attr('href') + ' #ajax-pagination>*');
      });
      $('.bean-toggle').click(function(){
        $('body, html').scrollTop($('#ajax-posts').offset().top - 200);
      });

      // Resource Popups
      $('body').on('click', '.resource-popup-toggle', function(e){
        if ($(e.target).parents('.resource-popup').length < 1) {
          $(this).children('.resource-popup').addClass('open');
        }
      });
      $('body').on('click', '.close-resource-popup', function(){
        $('.resource-popup').removeClass('open');
      });

      // Pagination
      $('#ajax-pagination').on('click', 'a', function(e){
        e.preventDefault();
        $(this).remove();
        $('#ajax-loader').load($(this).attr('href') + ' #ajax-posts>*', function(){
          $('#ajax-posts').append($('#ajax-loader').html());
        });
        $('#ajax-pagination').load($(this).attr('href') + ' #ajax-pagination>*');
      });

      // Search
      $('.search-toggle').click(function(e){
        e.preventDefault();
        $('html, body').stop().animate({
          scrollTop: 0
        });
        $('#search-popup').toggleClass('active');
        $('#global-header').toggleClass('search-open');
        $('#search-input').focus();
      });
      $('.close-search').click(function(){
        $('#search-popup').removeClass('active');
        $('#global-header').removeClass('search-open');
      });
      if ($(window).width() < 991) {
        $('#search-input').attr('placeholder', 'Keyword...');
        $('#search-submit').text('Go');
      }

      // Cookied Popup
      var $delay = 0;
      if ($('.cookied-popup').length) {
        $delay = $('.cookied-popup').data('delay');
        setTimeout(function(){
          $('.cookied-popup').addClass('visible');
        }, $delay);
      }
      $('.close-cookie-popup').on('click', function(){
        $('.cookied-popup').fadeOut();
        $.cookie('popup', $('.cookied-popup').attr('id'), { path: '/' });
      });

      // Anchor
      $('a:not(.endnote)').on('click', function(e){
        var $href = $(this).attr('href'),
            $anchor = $href;
        if ($anchor.indexOf('#') > -1) {
          if (!$anchor.match('^#')) {
            $anchor = $anchor.substr($anchor.indexOf('#'));
          }
          if ($($anchor).length > 0) {
            e.preventDefault();
            $('html, body').stop().animate({
              scrollTop: $($anchor).offset().top
            });
          } else {
            window.location.href = $href;
          }
        }
      });

      // Endnote
      $('.endnotes-toggle').on('click', function(){
        $(this).parents('.endnotes-wrapper').toggleClass('open');
      })
      $(window).resize(function(){
        $('.endnote-popup').remove();
      });
      $('a.endnote').on('click', function(e){
        e.preventDefault();
        $('.endnote-popup').remove();
        if ($($(this).attr('href')).length) {
          $('body').append('<div class="endnote-popup" style="left: ' + $(this).offset().left  + 'px; top: ' + ($(this).offset().top + 40) + 'px;">' + $($(this).attr('href')).html() + '<svg class="close-icon" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-1" x2="20.6968" y2="-1" transform="matrix(0.724751 0.689011 -0.724751 0.689011 1 2)" stroke="#959494" stroke-width="2"/><line y1="-1" x2="20.6968" y2="-1" transform="matrix(0.724751 -0.689011 0.724751 0.689011 2.33008 16.2603)" stroke="#959494" stroke-width="2"/></svg></div>');
        }
      });
      $('body').on('click', '.endnote-popup .close-icon', function(){
        $(this).parent('.endnote-popup').remove();
      });

      // Video popups
      $('a').on('click', function(e){
        var $target = $(this).attr('href');
        if ($target.toLowerCase().indexOf("vimeo") >= 0 && !$(this).hasClass('resource-link')) {
          e.preventDefault();
          var $n = $target.lastIndexOf('/');
          var $vid = $target.substring($n + 1);
          $('.popup-content').html('<iframe src="https://player.vimeo.com/video/' + $vid + '/?autoplay=1&api=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
        if ($target.toLowerCase().indexOf("youtu") >= 0 && !$(this).hasClass('social-link') && !$(this).hasClass('resource-link')) {
          e.preventDefault();
          var $y = $target.lastIndexOf('=');
          var $yid = $target.substring($y + 1);
          $('.popup-content').html('<iframe src="https://www.youtube.com/embed/' + $yid + '/?autoplay=1" width="500" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
          $('.video-popup-wrapper').addClass('active');
          $('body, html').addClass('body-noscroll');
        }
      });
      $('.close-popup').on('click', function(){
        $('.video-popup-wrapper').removeClass('active');
        $('.popup-content').html('');
        $('body, html').removeClass('body-noscroll');
      });

      // Mobile Nav
      $('#mobile-nav-toggle').on('click', function(){
        var $navheight = $('#mobile-navigation').height() + 170;
        $('body, html').toggleClass('nav-locked');
        $('#mobile-navigation-wrapper').toggleClass('active');
        $(this).toggleClass('active');
      });

      // Resize for Match-Height and Slick-Slider glitch fix
      this.scroll_actions;
      $(window).bind('load', function(){
        $(window).trigger('resize');
        setTimeout(function(){ $(window).trigger('resize'); }, 500);
        this.scroll_actions;
      });
      $(document).ready(this.scroll_actions);
      $(window).scroll(this.scroll_actions);
    },
    scroll_actions: function() {
      $('.animate').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          $this.addClass('visible');
        }
      });
      $('.animate-1').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 100);
        }
      });
      $('.animate-2').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 200);
        }
      });
      $('.animate-3').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 300);
        }
      });
      $('.animate-4').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 400);
        }
      });
      $('.animate-5').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 500);
        }
      });
      $('.animate-6').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 600);
        }
      });
      $('.animate-7').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 700);
        }
      });
      $('.animate-8').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 800);
        }
      });
      $('.animate-9').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 900);
        }
      });
      $('.animate-10').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1000);
        }
      });
      $('.animate-11').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1100);
        }
      });
      $('.animate-12').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1200);
        }
      });
      $('.animate-13').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1300);
        }
      });
      $('.animate-14').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1400);
        }
      });
      $('.animate-15').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1500);
        }
      });
      $('.animate-16').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1600);
        }
      });
      $('.animate-17').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1700);
        }
      });
      $('.animate-18').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1800);
        }
      });
      $('.animate-19').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 1900);
        }
      });
      $('.animate-20').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2000);
        }
      });
      $('.animate-21').each(function(){
        var $this = $(this);
        if ($this.offset().top < $(window).scrollTop() + $(window).height() - 100) {
          setTimeout(function(){
            $this.addClass('visible');
          }, 2100);
        }
      });
    }
  },
  // Home page
  home: {
    init: function() {
      // JavaScript to be fired on the home page
    }
  }
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var namespace = Base;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
    UTIL.fire('common');

    $.each(document.body.className.replace(/-/g, '_').split(/\s+/),function(i,classnm) {
      UTIL.fire(classnm);
    });
  }
};

$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.